/**
 * Restituisce true se l'app è stata avviata come PWA (standalone),
 * ad es. aperta dall'icona nella home screen invece che dal browser.
 * Sul server restituisce sempre false.
 */
export function useIsPwa(): boolean {
	if (import.meta.server) {
		return false;
	}
	// display-mode: standalone quando installata come PWA (Chrome, Android, ecc.)
	const standalone = window.matchMedia('(display-mode: standalone)').matches;
	// iOS Safari: true quando aperta da "Aggiungi a Home"
	const iosStandalone = (window.navigator as { standalone?: boolean }).standalone === true;
	return standalone || iosStandalone;
}
